import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import { AxiosError } from 'axios';
import { getErrorDetail } from 'Services/errors';
import i18n from 'Services/i18n';
import Notify, { AlertTypes } from 'Services/notification';
import ReferralService from 'Services/referral';
import { PatchClabe, QueryKeys } from 'Types/common';

export const usePatchUserClabe = (closeModal: () => void): UseMutationResult<unknown, PatchClabe> =>
  useMutation([QueryKeys.SAVE_CLABE_MUTATION], ReferralService.patchUserClabe, {
    onSuccess: () => {
      Notify.sendNotification(i18n.t('mgm:Referral.save.clabe.success'), AlertTypes.success);
    },
    onError: (err: AxiosError) => {
      if (err) {
        Notify.sendNotification(getErrorDetail(err), AlertTypes.error);
      }
    },
    onSettled: () => {
      closeModal();
    },
  });
